import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './AtelierPageKindOverlay.css';

// PAGES « TEXTE SEUL » A PRERGLAGES (Dedicace, Chapitre, Remerciements) — on REMPLIT DIRECTEMENT SUR LA PAGE
// (retour utilisateur, 2026-10-16 : « il faut remonter vers le haut pour remplir les champs dédiés... je pense qu'il
// faut remplir directement sur la page »). La page est mise en forme comme le livre final, avec des zones
// « Remplir ici » aux endroits ou le texte apparaitra. Plus de formulaire dans le panneau.
//
// Les champs sont les memes qu'avant (title / text / number / photoItemId, voir pageModel.js) et passent par le meme
// enregistrement automatique : onFieldChange(champ, valeur).

function AutoTextarea({ value, onChange, placeholder, maxLength, className, autoFocus }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = '0px';
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);
  useEffect(() => {
    if (autoFocus && ref.current) {
      ref.current.focus();
      ref.current.setSelectionRange(ref.current.value.length, ref.current.value.length);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <textarea
      ref={ref}
      className={className}
      value={value}
      rows={1}
      maxLength={maxLength}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}

function Labelled({ label, children }) {
  return (
    <div className="kind-field">
      <span className="kind-field-label">{label}</span>
      {children}
    </div>
  );
}

function AtelierPageKindOverlay({ kind, fields, onFieldChange, photos, onPickPhoto }) {
  const { t } = useTranslation('atelier');
  const stop = (event) => event.stopPropagation();

  if (kind === 'chapter-divider-manuel') {
    const photo = (photos || []).find((item) => item.id === fields.photoItemId);
    const url = photo && (photo.metadata?.previewUrl || photo.metadata?.thumbnailUrl || photo.url);
    return (
      <div className="kind-overlay kind-chapter" onClick={stop}>
        <div className="kind-chapter-photo" style={url ? { backgroundImage: `url('${url}')` } : undefined}>
          <button type="button" className="kind-chapter-pick" onClick={onPickPhoto}>
            {url ? t('pageKindOverlay.changePhoto') : `+ ${t('pageKindOverlay.addPhoto')}`}
          </button>
        </div>
        <div className="kind-chapter-bottom">
          <Labelled label={t('pageKindOverlay.chapterNumber')}>
            <input
              className="kind-number"
              type="text"
              value={fields.number}
              maxLength={20}
              placeholder={t('pageKindOverlay.chapterNumberPlaceholder')}
              onChange={(event) => onFieldChange('number', event.target.value)}
            />
          </Labelled>
          <Labelled label={t('pageKindOverlay.chapterTitle')}>
            <AutoTextarea
              className="kind-chapter-title"
              value={fields.title}
              maxLength={120}
              placeholder={t('pageKindOverlay.chapterTitlePlaceholder')}
              onChange={(value) => onFieldChange('title', value.replace(/\n/g, ' '))}
              autoFocus={Boolean(url) && !fields.title}
            />
          </Labelled>
        </div>
      </div>
    );
  }

  if (kind === 'thank-you') {
    return (
      <div className="kind-overlay" onClick={stop}>
      <div className="kind-centered">
        <Labelled label={t('pageKindOverlay.thanksLabel')}>
          <AutoTextarea
            className="kind-text"
            value={fields.text}
            maxLength={600}
            placeholder={t('pageKindOverlay.thanksPlaceholder')}
            onChange={(value) => onFieldChange('text', value)}
            autoFocus
          />
        </Labelled>
        <p className="kind-note">{t('pageKindOverlay.thanksNote')}</p>
      </div>
      </div>
    );
  }

  // dedication
  return (
    <div className="kind-overlay" onClick={stop}>
      <div className="kind-centered">
      <span className="kind-ornament" aria-hidden="true" />
      <Labelled label={t('pageKindOverlay.dedicationTitleLabel')}>
        <input
          className="kind-title"
          type="text"
          value={fields.title}
          maxLength={120}
          placeholder={t('pageKindOverlay.dedicationTitlePlaceholder')}
          onChange={(event) => onFieldChange('title', event.target.value)}
        />
      </Labelled>
      <Labelled label={t('pageKindOverlay.dedicationTextLabel')}>
        <AutoTextarea
          className="kind-text"
          value={fields.text}
          maxLength={600}
          placeholder={t('pageKindOverlay.dedicationTextPlaceholder')}
          onChange={(value) => onFieldChange('text', value)}
          autoFocus
        />
      </Labelled>
      <span className="kind-ornament" aria-hidden="true" />
      </div>
    </div>
  );
}

export default AtelierPageKindOverlay;
